import React from "react";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ProductType } from "../../types/types";
import styles from "./SkipLinks.module.scss";
import { PRODUCT_DESCRIPTION_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/ProductDescriptionAccordion/ProductDescriptionAccordionUI";
import { PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME } from "../ProductAccordion/components/ProductDeliveryOptionsAccordion/ProductDeliveryOptionsAccordionUI";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";

type Props = {
  /**
   * The type of the product.
   */
  productType: ProductType;
  /**
   * A boolean indicating whether the product is active.
   */
  isActive: boolean;
  /**
   * A boolean indicating whether the product is available in stores only.
   */
  isInStoreOnly: boolean;
};

const accordionInstances: Record<string, string> = {
  "#accordion-description": PRODUCT_DESCRIPTION_ACCORDION_INSTANCE_NAME,
  "#accordion-delivery": PRODUCT_DELIVERY_OPTIONS_ACCORDION_INSTANCE_NAME,
};

function dispatchAccordionOpenEvent(target: string) {
  const event = new CustomEvent(
    `jlds:accordion:${accordionInstances[target]}`,
    {
      detail: { action: "open" },
    },
  );
  document.body.dispatchEvent(event);
}

export const SkipLinksUI = ({
  productType,
  isActive,
  isInStoreOnly,
}: Props) => {
  if (productType?.includes("StaticBundle")) return null;

  const scrollToTarget = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const hrefTarget = e.currentTarget.getAttribute("href") || "";

    dispatchMonetateQEvent(
      `pdp:skiplinks:click:${accordionInstances[hrefTarget]}`,
    );

    dispatchAccordionOpenEvent(hrefTarget);

    const scrollIntoView = () =>
      document
        .querySelector(hrefTarget)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });

    setTimeout(scrollIntoView, 0);
  };

  return (
    <div
      data-testid="skiplinks"
      className={styles.container}
      data-component="SkipLinks"
    >
      {isActive && !isInStoreOnly && (
        <UnderlinedButton
          tag="a"
          data-testid="skiplinks:delivery"
          href="#accordion-delivery"
          onClick={scrollToTarget}
        >
          Delivery & returns
        </UnderlinedButton>
      )}
      <UnderlinedButton
        tag="a"
        data-testid="skiplinks:description"
        href="#accordion-description"
        onClick={scrollToTarget}
      >
        Product description
      </UnderlinedButton>
    </div>
  );
};
